const ageFactorTable = {
    40: { '0-2': 1.0, '3-5': 1.025, '6-8': 1.05, '9-11': 1.075 },
    41: { '0-2': 1.1, '3-5': 1.125, '6-8': 1.15, '9-11': 1.175 },
    42: { '0-2': 1.2, '3-5': 1.225, '6-8': 1.25, '9-11': 1.275 },
    43: { '0-2': 1.3, '3-5': 1.325, '6-8': 1.35, '9-11': 1.375 },
    44: { '0-2': 1.4, '3-5': 1.425, '6-8': 1.45, '9-11': 1.475 },
    45: { '0-2': 1.5, '3-5': 1.525, '6-8': 1.55, '9-11': 1.575 },
    46: { '0-2': 1.6, '3-5': 1.625, '6-8': 1.65, '9-11': 1.675 },
    47: { '0-2': 1.7, '3-5': 1.725, '6-8': 1.75, '9-11': 1.775 },
    48: { '0-2': 1.8, '3-5': 1.825, '6-8': 1.85, '9-11': 1.875 },
    49: { '0-2': 1.9, '3-5': 1.925, '6-8': 1.95, '9-11': 1.975 },
    50: { '0-2': 2.0, '3-5': 2.025, '6-8': 2.05, '9-11': 2.075 },
    51: { '0-2': 2.1, '3-5': 2.125, '6-8': 2.15, '9-11': 2.175 },
    52: { '0-2': 2.2, '3-5': 2.225, '6-8': 2.25, '9-11': 2.275 },
    53: { '0-2': 2.3, '3-5': 2.325, '6-8': 2.35, '9-11': 2.375 },
    54: { '0-2': 2.4, '3-5': 2.425, '6-8': 2.45, '9-11': 2.475 },
    55: { '0-2': 2.5, '3-5': 2.525, '6-8': 2.55, '9-11': 2.575 },
    56: { '0-2': 2.6, '3-5': 2.625, '6-8': 2.65, '9-11': 2.675 },
    57: { '0-2': 2.7, '3-5': 2.725, '6-8': 2.75, '9-11': 2.775 },
    58: { '0-2': 2.8, '3-5': 2.825, '6-8': 2.85, '9-11': 2.875 },
    59: { '0-2': 2.9, '3-5': 2.925, '6-8': 2.95, '9-11': 2.975 },
    60: { '0-2': 3.0, '3-5': 3.025, '6-8': 3.05, '9-11': 3.075 },
    61: { '0-2': 3.1, '3-5': 3.125, '6-8': 3.15, '9-11': 3.175 },
    62: { '0-2': 3.2, '3-5': 3.225, '6-8': 3.25, '9-11': 3.275 },
    63: { '0-2': 3.3, '3-5': 3.325, '6-8': 3.35, '9-11': 3.375 },
    64: { '0-2': 3.4, '3-5': 3.425, '6-8': 3.45, '9-11': 3.475 },
};

function getAgeFactor(ageYears, ageMonths) {
    const monthsRanges = Object.keys(ageFactorTable[ageYears] || {});

    for (const range of monthsRanges) {
        const [min, max] = range.split('-').map(Number);
        if (ageMonths >= min && ageMonths <= max) {
            return ageFactorTable[ageYears][range];
        }
    }

    return null; // If no matching range is found
}

export { getAgeFactor }